import { getInitials, getRandomElement } from 'app/src/shared/helpers'
import { Avatar } from 'primereact/avatar'
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'

export function Persona(props: {
  label: string
  onClickCancelButton?: () => void
  btnCancelAriaLabel?: string
  btnCancelVisibility?: boolean
}) {
  const [avColor, setAvColor] = useState<string>()
  const avatarColors = [
    '#2196F3',
    '#004e8c',
    '#0b6a0b',
    '#ca5010',
    '#8764b8',
    '#5c2e91',
    '#0078d4',
    '#2d7d9a',
    '#b4009e',
    '#e81123',
    '#ff8c00',
    '#107c10',
    '#5c2d91',
    '#ffb900',
    '#00b7c3',
    '#d83b01',
    '#e3008c',
    '#8e8cd8',
    '#00bcf2',
    '#bad80a',
    '#f7630c',
    '#ca5010',
    '#c239b3',
    '#9a0089',
    '#0078d7',
    '#00a2ed',
  ]

  useEffect(() => {
    if (!avColor) setAvColor(getRandomElement(avatarColors))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='m-1 flex'>
      <div className='flex flex-row items-center rounded-lg bg-[#D9EBFF] px-1 py-0'>
        <Avatar
          label={getInitials(props.label)}
          //size='large'
          className={`m-1 h-10 w-10 font-semibold text-[#ffffff]`}
          style={{ backgroundColor: avColor }}
          shape='circle'
        />
        <div className='mx-1 text-[14px] font-normal leading-4 text-black'>{props.label.toUpperCase()}</div>
        {props.btnCancelVisibility && (
          <Button
            icon='pi pi-times'
            className='mx-1 my-0 h-5 w-5 border-none p-1 text-black hover:bg-[#F6F6F6] hover:text-black'
            link
            aria-label={props.btnCancelAriaLabel}
            onClick={props.onClickCancelButton!}
          />
        )}
      </div>
    </div>
  )
}
